import { PersonalFl44APIService } from './fl44';
import { PersonalFl223APIService } from './fl223';
import { PersonalCommercialAPIService } from './commercial';
import { PersonalAddressesAPIService } from './addresses';
import { PersonalProfileAPIService } from './profile';
import { PersonalFl44ExternalPurchasesAPIService } from '@/services/backend/personal/external_purchases';
import { PersonalAccountingAPIService } from '@/services/backend/personal/accounting';
import { PersonalRatingHistoryAPIService } from '@/services/backend/personal/rating-history';
import { PersonalOrganizationProfileAPIService } from '@/services/backend/personal/organization-profile';
import { PersonalFl44UnknownVolumeAPIService } from '@/services/backend/personal/fl44-unknown-volume';

export default {
    fl44: new PersonalFl44APIService(),
    fl44UnknownVolume: new PersonalFl44UnknownVolumeAPIService(),
    fl44ExternalPurchases: new PersonalFl44ExternalPurchasesAPIService(),
    fl223: new PersonalFl223APIService(),
    commercial: new PersonalCommercialAPIService(),
    accounting: new PersonalAccountingAPIService(),
    addresses: new PersonalAddressesAPIService(),
    profile: new PersonalProfileAPIService(),
    organizationProfile: new PersonalOrganizationProfileAPIService(),
    ratingHistory: new PersonalRatingHistoryAPIService()
};
